/**
 * Labstep
 *
 * @module components/ResourceLocationMap/Action/CreateMap
 * @desc CreateMap Resource Location Map Action
 */

import { EntityActionEdit } from 'labstep-web/components/Entity/Action/Edit';
import { ResourceLocationFormCreateMap } from 'labstep-web/components/ResourceLocation/Form/Create/Map';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IResourceLocationActionCreateMapProps } from './types';

export const ResourceLocationActionCreateMap: React.FC<
  IResourceLocationActionCreateMapProps
> = ({ resourceLocation, actionComponentProps }) => (
  <ModalDefault
    header="Select Grid Size"
    content={({ toggleModal }) => (
      <ResourceLocationFormCreateMap
        resourceLocation={resourceLocation}
        options={{ onSuccess: toggleModal }}
      />
    )}
    viewComponent={({ toggleModal }) => (
      <EntityActionEdit
        entity={resourceLocation}
        actionComponentProps={{
          type: 'button',
          icon: 'plus',
          text: 'Create Map',
          onClick: toggleModal,
          ...actionComponentProps,
        }}
      />
    )}
  />
);
